import { useState, useEffect } from "react";
import { saveTaskDetails, createSubTask } from "../Api/TaskMaster";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Alert,
  Card,
  Modal,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { fetchProjectDetails } from "../Api/ViewProjects";
import { getTeamById } from "../Api/TeamMaster";
import { getUsersByIds } from "../Api/Auth";
import { getTemplatesByOrg } from "../Api/TaskTemplate";
import { fetchStagesByProject } from "../Api/StageMaster";
import moment from "moment";
import TaskTemplateModal from "./TaskTemplateModal"; // Add this import

const TaskMaster = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [preselectedProject, setPreselectedProject] = useState(null);
  const [isProjectPreselected, setIsProjectPreselected] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMemberDetails, setTeamMemberDetails] = useState([]);
  const [loadingTeam, setLoadingTeam] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);

  // Stage states
  const [stages, setStages] = useState([]);
  const [loadingStages, setLoadingStages] = useState(false);

  // Template states
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingTemplates, setLoadingTemplates] = useState(false);

  // SubTask states
  const [subTasks, setSubTasks] = useState([]);
  const [showSubTaskModal, setShowSubTaskModal] = useState(false);
  const [subTaskLoading, setSubTaskLoading] = useState(false);
  const [subTaskForm, setSubTaskForm] = useState({
    SubTaskName: "",
    SubTaskDescription: "",
    SubTaskAssignedTo: "",
    SubTaskStatus: "Pending",
    SubTaskDueDate: "",
    SubTaskActualStateDate: "",
    SubTaskActualEndDate: "",
  });

  // Refresh templates after creating a new one
  const handleTemplateCreated = () => {
    loadTemplates(); // Reload templates to include the new one
    toast.success("Template created successfully!");
  };

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;
  const username = userDetails?.username;

  // Get projectId from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const preselectedProjectId = queryParams.get("projectId");
  const preselectedTicketId = queryParams.get("ticketId");
  const preselectedEventCode = queryParams.get("eventCode");
  console.log(preselectedProjectId, "Preselected Project ID");
  console.log(preselectedTicketId, "Preselected Ticket ID");
  console.log(preselectedEventCode, "Preselected Event Code");

  const [taskData, setTaskData] = useState({
    orgId: String(orgId) || "",
    taskName: "",
    projectBelong: preselectedProjectId || "",
    stageBelong: "",
    assignedTo: "",
    taskStartDate: "",
    taskEndDate: "",
    taskType: "",
    taskPriority: "",
    taskStatus: "",
    taskDescription: "",
    actualStartDate: "",
    actualEndDate: "",
    createdBy: username || String(userId) || "",
    TaskTicketFor: preselectedTicketId || "",
    TaskEventFor: preselectedEventCode || "",
  });

  console.log(taskData, "Task Data");

  // Available task fields configuration
  const availableFields = [
    {
      field: "taskName",
      displayName: "Task Name",
      type: "text",
      required: true,
    },
    {
      field: "taskDescription",
      displayName: "Task Description",
      type: "textarea",
      required: false,
    },
    {
      field: "assignedTo",
      displayName: "Assigned To",
      type: "select",
      required: false,
    },
    {
      field: "stageBelong",
      displayName: "Stage",
      type: "select",
      required: false,
    },
    {
      field: "taskStartDate",
      displayName: "Planned Start Date",
      type: "date",
      required: false,
    },
    {
      field: "taskEndDate",
      displayName: "Planned End Date",
      type: "date",
      required: false,
    },
    {
      field: "actualStartDate",
      displayName: "Actual Start Date",
      type: "date",
      required: false,
    },
    {
      field: "actualEndDate",
      displayName: "Actual End Date",
      type: "date",
      required: false,
    },
    {
      field: "taskType",
      displayName: "Task Type",
      type: "select",
      required: false,
    },
    {
      field: "taskPriority",
      displayName: "Priority",
      type: "select",
      required: false,
    },
    {
      field: "taskStatus",
      displayName: "Status",
      type: "select",
      required: false,
    },
    {
      field: "includeSubTasks",
      displayName: "Include Sub Tasks",
      type: "checkbox",
      required: false,
    },
  ];

  // Function to convert empty strings to null
  const sanitizeTaskData = (data) => {
    const sanitized = { ...data };
    Object.keys(sanitized).forEach((key) => {
      if (sanitized[key] === "") {
        sanitized[key] = null;
      }
    });

    const dateFields = [
      "taskStartDate",
      "taskEndDate",
      "actualStartDate",
      "actualEndDate",
    ];
    dateFields.forEach((field) => {
      if (sanitized[field] === "") {
        sanitized[field] = null;
      }
    });

    return sanitized;
  };

  // SubTask handlers
  const handleAddSubTask = () => {
    setSubTaskForm({
      SubTaskName: "",
      SubTaskDescription: "",
      SubTaskAssignedTo: taskData.assignedTo || "",
      SubTaskStatus: "Pending",
      SubTaskDueDate: taskData.taskEndDate || "",
      SubTaskActualStateDate: "",
      SubTaskActualEndDate: "",
      SubTaskCreatedBy: String(userId) || "",
    });
    setShowSubTaskModal(true);
  };
  console.log("SubTask Form Data:", subTaskForm);

  const handleSubTaskFormChange = (field, value) => {
    setSubTaskForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubTaskSubmit = async () => {
    if (!subTaskForm.SubTaskName.trim()) {
      toast.error("SubTask name is required");
      return;
    }

    setSubTaskLoading(true);
    try {
      const newSubTask = {
        ...subTaskForm,
        subTaskId: `subtask-${Date.now()}`, // Temporary ID for UI
      };

      setSubTasks((prev) => [...prev, newSubTask]);
      toast.success("SubTask added successfully");
      setShowSubTaskModal(false);
    } catch (error) {
      console.error("Error creating subtask:", error);
      toast.error("Failed to create subtask");
    } finally {
      setSubTaskLoading(false);
    }
  };

  // Check if subtasks should be shown based on template
  const shouldShowSubTasks = () => {
    if (!selectedTemplate) return true; // Show by default when no template selected
    return (
      selectedTemplate.includeFields &&
      selectedTemplate.includeFields.includeSubTasks
    );
  };

  const removeSubTask = (index) => {
    setSubTasks((prev) => prev.filter((_, i) => i !== index));
    toast.info("SubTask removed");
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      Active: "status-active",
      Completed: "status-completed",
      Pending: "status-pending",
      "In Progress": "status-in-progress",
    };
    return statusMap[status] || "status-pending";
  };

  // Load templates for the organization
  const loadTemplates = async () => {
    if (!orgId) return;
    setLoadingTemplates(true);
    try {
      const templatesData = await getTemplatesByOrg(orgId);
      setTemplates(templatesData || []);
    } catch (error) {
      console.error("Error loading templates:", error);
      toast.error("Failed to load task templates");
      setTemplates([]);
    } finally {
      setLoadingTemplates(false);
    }
  };

  // Handle template selection
  const handleTemplateSelect = (templateId) => {
    if (!templateId) {
      setSelectedTemplate(null);
      return;
    }
    const template = templates.find((t) => t.templateId === templateId);
    setSelectedTemplate(template);
    if (template) {
      toast.info(
        `Template "${template.templateName}" selected. Showing ${
          Object.keys(template.includeFields || {}).length
        } fields.`,
      );
    }
  };

  // Check if a field should be shown based on selected template
  const shouldShowField = (fieldName) => {
    if (!selectedTemplate) return true;
    return (
      selectedTemplate.includeFields &&
      selectedTemplate.includeFields[fieldName]
    );
  };

  // Check if a field is required based on template
  const isFieldRequired = (fieldName) => {
    if (!selectedTemplate) {
      const fieldConfig = availableFields.find((f) => f.field === fieldName);
      return fieldConfig?.required || false;
    }
    return (
      selectedTemplate.includeFields &&
      selectedTemplate.includeFields[fieldName]
    );
  };

  // Fetch user details for team members
  const fetchUserDetails = async (userIds) => {
    if (!userIds || userIds.length === 0) {
      setTeamMemberDetails([]);
      return;
    }
    try {
      setLoadingUsers(true);
      const numericUserIds = userIds
        .map((id) => parseInt(id))
        .filter((id) => !isNaN(id));
      if (numericUserIds.length === 0) {
        setTeamMemberDetails([]);
        return;
      }
      const response = await getUsersByIds(numericUserIds);
      if (response && response.users) {
        setTeamMemberDetails(response.users);
      } else {
        setTeamMemberDetails([]);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      setTeamMemberDetails([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Fetch team members when project is selected
  const fetchTeamMembers = async (teamId) => {
    if (!teamId) return;
    try {
      setLoadingTeam(true);
      const teamData = await getTeamById(teamId);
      if (teamData && teamData.teamMembers) {
        setTeamMembers(teamData.teamMembers);
        await fetchUserDetails(teamData.teamMembers);
      } else {
        setTeamMembers([]);
        setTeamMemberDetails([]);
      }
    } catch (error) {
      console.error("Error fetching team members:", error);
      setTeamMembers([]);
      setTeamMemberDetails([]);
    } finally {
      setLoadingTeam(false);
    }
  };

  // Function to load stages for the project
  const loadProjectStages = async (projectId) => {
    if (!projectId) return;
    setLoadingStages(true);
    try {
      const stagesData = await fetchStagesByProject(projectId);
      setStages(stagesData || []);
    } catch (error) {
      console.error("Error loading project stages:", error);
      setStages([]);
    } finally {
      setLoadingStages(false);
    }
  };

  // Fetch preselected project data
  useEffect(() => {
    const fetchPreselectedProject = async () => {
      if (preselectedProjectId) {
        try {
          setLoading(true);
          const projectData = await fetchProjectDetails(preselectedProjectId);
          setPreselectedProject(projectData);
          setIsProjectPreselected(true);
          toast.info(`Adding task to project: ${projectData.prTitle}`);
          await Promise.all([
            projectData.teamAssigned
              ? fetchTeamMembers(projectData.teamAssigned)
              : Promise.resolve(),
            loadProjectStages(preselectedProjectId),
          ]);
        } catch (error) {
          console.error("Error fetching preselected project:", error);
          toast.error("Error loading project details");
        } finally {
          setLoading(false);
        }
      }
    };
    if (preselectedProjectId) {
      fetchPreselectedProject();
    }
  }, [preselectedProjectId]);

  // Load templates when component mounts
  useEffect(() => {
    loadTemplates();
  }, [orgId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value === "") {
      setTaskData((prev) => ({ ...prev, [name]: null }));
    } else {
      setTaskData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (value === "") {
      setTaskData((prev) => ({ ...prev, [name]: null }));
    } else {
      setTaskData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     // Validate required fields based on template
  //     if (selectedTemplate) {
  //       const missingFields = [];
  //       Object.keys(selectedTemplate.includeFields || {}).forEach(
  //         (fieldName) => {
  //           if (!taskData[fieldName] && taskData[fieldName] !== false) {
  //             const fieldConfig = availableFields.find(
  //               (f) => f.field === fieldName
  //             );
  //             if (fieldConfig) {
  //               missingFields.push(fieldConfig.displayName);
  //             }
  //           }
  //         }
  //       );

  //       if (missingFields.length > 0) {
  //         toast.error(
  //           `Please fill in all required fields: ${missingFields.join(", ")}`
  //         );
  //         setLoading(false);
  //         return;
  //       }
  //     }

  //     // Sanitize the data before sending
  //     const sanitizedData = sanitizeTaskData(taskData);
  //     console.log("Sending sanitized task data:", sanitizedData);

  //     // Save main task first
  //     const savedTask = await saveTaskDetails(
  //       sanitizedData,
  //       username || userId
  //     );

  //     // Save subtasks if any
  //     if (subTasks.length > 0 && savedTask && savedTask.taskId) {
  //       for (const subTask of subTasks) {
  //         const subTaskData = {
  //           ...subTask,
  //           SubTaskBelongTask: savedTask.taskId,
  //           SubTaskCreatedBy: String(userId) || "",
  //         };
  //         console.log("Creating subtask with data:", subTaskData);
  //         await createSubTask(subTaskData, username);
  //       }
  //       toast.success(
  //         `Task and ${subTasks.length} subtask(s) created successfully`
  //       );
  //     } else {
  //       toast.success("Task Added Successfully");
  //     }

  //     // Reset form
  //     setTaskData({
  //       orgId: String(orgId) || "",
  //       taskName: "",
  //       projectBelong: preselectedProjectId || "",
  //       stageBelong: "",
  //       assignedTo: "",
  //       taskStartDate: "",
  //       taskEndDate: "",
  //       taskType: "",
  //       taskPriority: "",
  //       taskStatus: "",
  //       taskDescription: "",
  //       actualStartDate: "",
  //       actualEndDate: "",
  //       createdBy: username || String(userId) || "",
  //     });

  //     // Reset subtasks and template
  //     setSubTasks([]);
  //     setSelectedTemplate(null);

  //     // Navigate back
  //     if (preselectedProjectId) {
  //       navigate(`/project/${preselectedProjectId}`);
  //     } else {
  //       navigate("/viewTasks");
  //     }
  //   } catch (error) {
  //     toast.error(`Error saving task: ${error.message}`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate required fields based on template
      if (selectedTemplate) {
        const missingFields = [];
        Object.keys(selectedTemplate.includeFields || {}).forEach(
          (fieldName) => {
            // Skip validation for includeSubTasks as it's a special field
            if (fieldName === "includeSubTasks") return;

            if (!taskData[fieldName] && taskData[fieldName] !== false) {
              const fieldConfig = availableFields.find(
                (f) => f.field === fieldName,
              );
              if (fieldConfig) {
                missingFields.push(fieldConfig.displayName);
              }
            }
          },
        );

        if (missingFields.length > 0) {
          toast.error(
            `Please fill in all required fields: ${missingFields.join(", ")}`,
          );
          setLoading(false);
          return;
        }
      }

      // Sanitize the data before sending
      const sanitizedData = sanitizeTaskData(taskData);
      console.log("Sending sanitized task data:", sanitizedData);

      // Save main task first
      const savedTask = await saveTaskDetails(
        sanitizedData,
        username || userId,
      );

      // Save subtasks only if they should be shown (template includes subtasks or no template)
      if (
        shouldShowSubTasks() &&
        subTasks.length > 0 &&
        savedTask &&
        savedTask.taskId
      ) {
        for (const subTask of subTasks) {
          const subTaskData = {
            ...subTask,
            SubTaskBelongTask: savedTask.taskId,
            SubTaskCreatedBy: String(userId) || "",
          };
          console.log("Creating subtask with data:", subTaskData);
          await createSubTask(subTaskData, username);
        }
        toast.success(
          `Task and ${subTasks.length} subtask(s) created successfully`,
        );
      } else {
        toast.success("Task Added Successfully");
      }

      // Reset form
      setTaskData({
        orgId: String(orgId) || "",
        taskName: "",
        projectBelong: preselectedProjectId || "",
        stageBelong: "",
        assignedTo: "",
        taskStartDate: "",
        taskEndDate: "",
        taskType: "",
        taskPriority: "",
        taskStatus: "",
        taskDescription: "",
        actualStartDate: "",
        actualEndDate: "",
        createdBy: username || String(userId) || "",
        TaskTicketFor: preselectedTicketId || "",
        TaskEventFor: preselectedEventCode || "",
      });

      console.log(taskData);

      // Reset subtasks and template
      setSubTasks([]);
      setSelectedTemplate(null);

      // Navigate back
      if (preselectedProjectId) {
        navigate(`/project/${preselectedProjectId}`);
      } else {
        navigate("/viewTasks");
      }
    } catch (error) {
      toast.error(`Error saving task: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const getPreselectedProjectName = () => {
    if (preselectedProject) {
      return `${preselectedProject.prTitle} (${preselectedProject.projectId})`;
    }
    return "";
  };

  const getUserDisplayName = (memberId) => {
    const userDetail = teamMemberDetails.find(
      (user) => user.userId === parseInt(memberId),
    );
    if (userDetail) {
      return `${userDetail.username} (${userDetail.email})`;
    }
    return memberId;
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fields-title">Task Master</h2>

          <div className="d-flex align-items-center gap-3">
            {/* Create Template Button */}
            <Button
              variant="outline-primary"
              onClick={() => setShowTemplateModal(true)}
              className="d-flex align-items-center"
            >
              <i className="fas fa-plus me-2"></i>
              Create Template
            </Button>

            {/* Template Selection Dropdown */}
            <div className="template-selector" style={{ minWidth: "250px" }}>
              <Form.Group>
                <Form.Label>
                  <strong>Use Template (Optional)</strong>
                </Form.Label>
                <Form.Select
                  value={selectedTemplate?.templateId || ""}
                  onChange={(e) => handleTemplateSelect(e.target.value)}
                  disabled={loadingTemplates}
                >
                  <option value="">Select a template</option>
                  {templates.map((template) => (
                    <option
                      key={template.templateId}
                      value={template.templateId}
                    >
                      {template.templateName}
                      {template.includeFields &&
                        ` (${
                          Object.keys(template.includeFields).length
                        } fields)`}
                    </option>
                  ))}
                </Form.Select>
                {loadingTemplates && (
                  <Form.Text className="text-muted">
                    <small>Loading templates...</small>
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
        </div>

        {loading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        {/* Show info alert when project is preselected */}
        {isProjectPreselected && preselectedProject && (
          <Card
            className="mb-4 shadow-sm border-0"
            style={{
              background: "linear-gradient(135deg, #f8f9ff, #ffffff)",
              borderLeft: "5px solid #4f46e5",
            }}
          >
            <Card.Body className="py-3 px-4">
              <div className="d-flex justify-content-between align-items-center">
                {/* Left Section */}
                <div>
                  <div className="">
                    <i className="" style={{ color: "#4f46e5" }}></i>
                    <span className="text-uppercase text-muted fw-semibold small">
                      Selected Project
                    </span>
                  </div>

                  <h4 className="" style={{ marginTop: "10px" }}>
                    {preselectedProject.prTitle}
                    <span className="" style={{ marginLeft: "10px" }}>
                      ({preselectedProject.projectId})
                    </span>
                  </h4>

                  {/* <div
                      className="text-muted small"
                      style={{ marginTop: "10px" }}
                    >
                      <i className=""></i>
                      {teamMembers.length} team member
                      {teamMembers.length !== 1 && "s"} available
                    </div> */}
                </div>

                {/* Right Section
        <div className="text-end">
          <span className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-2">
            <i className="fas fa-tasks me-1"></i>
            Task Creation
          </span>
        </div> */}
              </div>
            </Card.Body>
          </Card>
        )}

        {/* Template Info Card */}
        {selectedTemplate && (
          <Card className="mb-4 border-primary">
            <Card.Body className="py-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>Using Template:</strong>{" "}
                  {selectedTemplate.templateName}
                  {selectedTemplate.templateDescription && (
                    <span className="text-muted ms-2">
                      - {selectedTemplate.templateDescription}
                    </span>
                  )}
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setSelectedTemplate(null)}
                >
                  Clear Template
                </Button>
              </div>
            </Card.Body>
          </Card>
        )}

        <Form onSubmit={handleSubmit} className="fields-form">
          {/* Basic Task Information */}
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Task Name <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="taskName"
                  value={taskData.taskName || ""}
                  onChange={handleChange}
                  required
                  placeholder="Enter task name"
                />
              </Form.Group>
            </Col>
            <Form.Control
              type="hidden"
              name="projectBelong"
              value={taskData.projectBelong || ""}
            />

            {/* <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project <span className="text-red">**</span>
                </Form.Label>
                {isProjectPreselected ? (
                  <>
                    <Form.Control
                      type="text"
                      value={getPreselectedProjectName()}
                      disabled
                      className="bg-light"
                    />
                    <Form.Text
                      className="text-muted"
                      style={{ fontSize: "11px" }}
                    >
                      Project is pre-selected. To change, go back to projects.
                    </Form.Text>
                  </>
                ) : (
                  <Form.Control
                    type="text"
                    value="No project selected"
                    disabled
                    className="bg-light"
                  />
                )}
                <Form.Control
                  type="hidden"
                  name="projectBelong"
                  value={taskData.projectBelong || ""}
                />
              </Form.Group>
            </Col> */}
          </Row>

          {/* Rest of your existing form fields remain the same */}
          <Row>
            {shouldShowField("assignedTo") && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Assigned To{" "}
                    {isFieldRequired("assignedTo") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Select
                    name="assignedTo"
                    value={taskData.assignedTo || ""}
                    onChange={handleChange}
                    required={isFieldRequired("assignedTo")}
                  >
                    <option value="">Select Team Member</option>
                    {teamMembers.map((memberId) => {
                      const displayName = getUserDisplayName(memberId);
                      return (
                        <option key={memberId} value={memberId}>
                          {displayName}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {shouldShowField("stageBelong") && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Stage{" "}
                    {isFieldRequired("stageBelong") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Select
                    name="stageBelong"
                    value={taskData.stageBelong || ""}
                    onChange={handleChange}
                    required={isFieldRequired("stageBelong")}
                  >
                    <option value="">Select Stage</option>
                    {stages.map((stage) => (
                      <option key={stage.stageId} value={stage.stageId}>
                        {stage.stageName} ({stage.stageId})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {/* Status - Conditionally shown */}
            {shouldShowField("taskStatus") && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Status{" "}
                    {isFieldRequired("taskStatus") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Select
                    name="taskStatus"
                    value={taskData.taskStatus || ""}
                    onChange={handleChange}
                    required={isFieldRequired("taskStatus")}
                  >
                    <option value="">Select Status</option>
                    <option value="New">New</option>
                    <option value="Not Started">Not Started</option>
                    <option value="In Progress">In Progress</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* Rest of your existing form fields */}
          {/* ... (keep all your existing date fields, priority, status, description fields) ... */}

          <Row>
            {shouldShowField("taskStartDate") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Planned Start Date{" "}
                    {isFieldRequired("taskStartDate") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="taskStartDate"
                    value={taskData.taskStartDate || ""}
                    onChange={handleDateChange}
                    required={isFieldRequired("taskStartDate")}
                  />
                </Form.Group>
              </Col>
            )}

            {shouldShowField("taskEndDate") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Planned End Date{" "}
                    {isFieldRequired("taskEndDate") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="taskEndDate"
                    value={taskData.taskEndDate || ""}
                    onChange={handleDateChange}
                    required={isFieldRequired("taskEndDate")}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            {shouldShowField("actualStartDate") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Actual Start Date{" "}
                    {isFieldRequired("actualStartDate") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="actualStartDate"
                    value={taskData.actualStartDate || ""}
                    onChange={handleDateChange}
                    required={isFieldRequired("actualStartDate")}
                  />
                </Form.Group>
              </Col>
            )}

            {shouldShowField("actualEndDate") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Actual End Date{" "}
                    {isFieldRequired("actualEndDate") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="actualEndDate"
                    value={taskData.actualEndDate || ""}
                    onChange={handleDateChange}
                    required={isFieldRequired("actualEndDate")}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            {/* Task Type - Conditionally shown */}
            {shouldShowField("taskType") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Task Type{" "}
                    {isFieldRequired("taskType") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Select
                    name="taskType"
                    value={taskData.taskType || ""}
                    onChange={handleChange}
                    required={isFieldRequired("taskType")}
                  >
                    <option value="">Select Task Type</option>
                    <option value="Development">Development</option>
                    <option value="Design">Design</option>
                    <option value="Testing">Testing</option>
                    <option value="Documentation">Documentation</option>
                    <option value="Research">Research</option>
                    <option value="Meeting">Meeting</option>
                    <option value="Maintenance">Maintenance</option>
                    <option value="Analysis">Analysis</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {shouldShowField("taskPriority") && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Priority{" "}
                    {isFieldRequired("taskPriority") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Select
                    name="taskPriority"
                    value={taskData.taskPriority || ""}
                    onChange={handleChange}
                    required={isFieldRequired("taskPriority")}
                  >
                    <option value="">Select Priority</option>
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                    <option value="Critical">Critical</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          {shouldShowField("taskDescription") && (
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Task Description{" "}
                    {isFieldRequired("taskDescription") && (
                      <span className="text-red">**</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="taskDescription"
                    value={taskData.taskDescription || ""}
                    onChange={handleChange}
                    placeholder="Enter detailed task description..."
                    maxLength={1000}
                    required={isFieldRequired("taskDescription")}
                  />
                  <Form.Text
                    className="text-muted"
                    style={{ fontSize: "11px" }}
                  >
                    {taskData.taskDescription?.length || 0}/1000 characters
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* Add SubTasks Section */}
          {/* Add SubTasks Section - Only show if template includes subtasks or no template selected */}
          {shouldShowSubTasks() && (
            <Card className="mb-4 border-warning">
              <Card.Header className="bg-warning bg-opacity-10 d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <i className="fas fa-list-ul me-2"></i>
                  Sub Tasks ({subTasks.length})
                </h6>
                <Button
                  variant="outline-warning"
                  size="sm"
                  onClick={handleAddSubTask}
                  className="add-sub-task-btn"
                  style={{ color: "black" }}
                >
                  {/* <i className="fas fa-plus me-1"></i> */}
                  Add Sub Task
                </Button>
              </Card.Header>
              <Card.Body className="p-0">
                {subTasks.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "20%" }}>SubTask Name</th>
                          <th style={{ width: "15%" }}>Assigned To</th>
                          <th style={{ width: "12%" }}>Status</th>
                          <th style={{ width: "12%" }}>Due Date</th>
                          <th style={{ width: "12%" }}>Start Date</th>
                          <th style={{ width: "12%" }}>End Date</th>
                          <th style={{ width: "7%" }} className="text-center">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {subTasks.map((subTask, index) => (
                          <tr key={index} className="align-middle">
                            <td>
                              <div>
                                <strong className="d-block">
                                  {subTask.SubTaskName}
                                </strong>
                                {subTask.SubTaskDescription && (
                                  <small
                                    className="text-muted d-block"
                                    title={subTask.SubTaskDescription}
                                  >
                                    {subTask.SubTaskDescription.length > 50
                                      ? `${subTask.SubTaskDescription.substring(
                                          0,
                                          50,
                                        )}...`
                                      : subTask.SubTaskDescription}
                                  </small>
                                )}
                              </div>
                            </td>
                            <td>
                              <span>
                                {subTask.SubTaskAssignedTo ? (
                                  getUserDisplayName(subTask.SubTaskAssignedTo)
                                ) : (
                                  <span className="text-muted">Unassigned</span>
                                )}
                              </span>
                            </td>
                            <td>
                              <Badge
                                bg={
                                  subTask.SubTaskStatus === "Completed"
                                    ? "success"
                                    : subTask.SubTaskStatus === "In Progress"
                                      ? "primary"
                                      : subTask.SubTaskStatus === "On Hold"
                                        ? "warning"
                                        : "secondary"
                                }
                              >
                                {subTask.SubTaskStatus}
                              </Badge>
                            </td>
                            <td>
                              {subTask.SubTaskDueDate ? (
                                moment(subTask.SubTaskDueDate).format(
                                  "MMM DD, YYYY",
                                )
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                            <td>
                              {subTask.SubTaskActualStateDate ? (
                                moment(subTask.SubTaskActualStateDate).format(
                                  "MMM DD, YYYY",
                                )
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                            <td>
                              {subTask.SubTaskActualEndDate ? (
                                moment(subTask.SubTaskActualEndDate).format(
                                  "MMM DD, YYYY",
                                )
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                            <td className="text-center">
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeSubTask(index)}
                                title="Remove subtask"
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center text-muted py-5">
                    <i className="fas fa-list-ul fa-3x mb-3 opacity-25"></i>
                    <p className="mb-0">No sub tasks added yet.</p>
                    <p className="small">Click "Add Sub Task" to create one.</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          <div className="fields-btn-container" style={{ display: "flex" }}>
            <Button
              variant="primary"
              type="submit"
              className="fields-submit"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : `Save Task${
                    shouldShowSubTasks() && subTasks.length > 0
                      ? ` & ${subTasks.length} SubTask(s)`
                      : ""
                  }`}
            </Button>
            <Button
              variant="secondary"
              type="button"
              className="fields-cancel ms-2"
              onClick={() => {
                if (preselectedProjectId) {
                  navigate(`/project/${preselectedProjectId}`);
                } else {
                  navigate("/viewTasks");
                }
              }}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Container>

      {/* SubTask Modal */}
      <Modal
        show={showSubTaskModal}
        onHide={() => setShowSubTaskModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-plus-circle me-2"></i>
            Add New Sub Task
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="g-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>SubTask Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={subTaskForm.SubTaskName}
                    onChange={(e) =>
                      handleSubTaskFormChange("SubTaskName", e.target.value)
                    }
                    placeholder="Enter subtask name"
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={subTaskForm.SubTaskDescription}
                    onChange={(e) =>
                      handleSubTaskFormChange(
                        "SubTaskDescription",
                        e.target.value,
                      )
                    }
                    placeholder="Enter subtask description"
                  />
                </Form.Group>
              </Col>

              {/* <Col md={6}>
                <Form.Group>
                  <Form.Label>Assigned To</Form.Label>
                  <Form.Control
                    type="text"
                    value={subTaskForm.SubTaskAssignedTo}
                    onChange={(e) =>
                      handleSubTaskFormChange(
                        "SubTaskAssignedTo",
                        e.target.value
                      )
                    }
                    placeholder="Assign to team member"
                  />
                </Form.Group>
              </Col> */}

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Assigned To</Form.Label>
                  <Form.Select
                    value={subTaskForm.SubTaskAssignedTo || ""}
                    onChange={(e) =>
                      handleSubTaskFormChange(
                        "SubTaskAssignedTo",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select Team Member</option>
                    {teamMembers.map((memberId) => {
                      const displayName = getUserDisplayName(memberId);
                      return (
                        <option key={memberId} value={memberId}>
                          {displayName}
                        </option>
                      );
                    })}
                  </Form.Select>
                  {teamMembers.length === 0 && (
                    <Form.Text
                      className="text-muted"
                      style={{ fontSize: "11px" }}
                    >
                      No team members available
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={subTaskForm.SubTaskStatus}
                    onChange={(e) =>
                      handleSubTaskFormChange("SubTaskStatus", e.target.value)
                    }
                  >
                    <option value="Pending">Pending</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Completed">Completed</option>
                    <option value="On Hold">On Hold</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Due Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={subTaskForm.SubTaskDueDate}
                    onChange={(e) =>
                      handleSubTaskFormChange("SubTaskDueDate", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Actual Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={subTaskForm.SubTaskActualStateDate}
                    onChange={(e) =>
                      handleSubTaskFormChange(
                        "SubTaskActualStateDate",
                        e.target.value,
                      )
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label> Actual End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={subTaskForm.SubTaskActualEndDate}
                    onChange={(e) =>
                      handleSubTaskFormChange(
                        "SubTaskActualEndDate",
                        e.target.value,
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSubTaskModal(false)}
            disabled={subTaskLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubTaskSubmit}
            disabled={subTaskLoading || !subTaskForm.SubTaskName.trim()}
          >
            {subTaskLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Adding...
              </>
            ) : (
              <>
                <i className="fas fa-save me-1"></i>
                Add Sub Task
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Task Template Creation Modal */}
      <TaskTemplateModal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        orgId={orgId}
        onTemplateSaved={handleTemplateCreated}
      />
    </div>
  );
};

export default TaskMaster;

// import { useState, useEffect } from "react";
// import { saveTaskDetails } from "../Api/TaskMaster";
// import {
//   Container,
//   Form,
//   Button,
//   Row,
//   Col,
//   Alert,
//   Card,
// } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { useNavigate, useLocation } from "react-router-dom";
// import Sample14 from "../Components/Logo";
// import { fetchProjectDetails } from "../Api/ViewProjects";
// import { getTeamById } from "../Api/TeamMaster";
// import { getUsersByIds } from "../Api/Auth";
// import { getTemplatesByOrg } from "../Api/TaskTemplate"; // Import template API
// import { fetchStagesByProject } from "../Api/StageMaster";

// const TaskMaster = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);
//   const [preselectedProject, setPreselectedProject] = useState(null);
//   const [isProjectPreselected, setIsProjectPreselected] = useState(false);
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [teamMemberDetails, setTeamMemberDetails] = useState([]);
//   const [loadingTeam, setLoadingTeam] = useState(false);
//   const [loadingUsers, setLoadingUsers] = useState(false);

//   // Stage states
//   const [stages, setStages] = useState([]);
//   const [loadingStages, setLoadingStages] = useState(false);

//   // Template states
//   const [templates, setTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [loadingTemplates, setLoadingTemplates] = useState(false);

//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const userId = userDetails?.userId;
//   const orgId = userDetails?.organisationId;
//   const username = userDetails?.username;

//   // Get projectId from URL query parameters
//   const queryParams = new URLSearchParams(location.search);
//   const preselectedProjectId = queryParams.get("projectId");

//   const [taskData, setTaskData] = useState({
//     orgId: String(orgId) || "",
//     taskName: "",
//     projectBelong: preselectedProjectId || "",
//     stageBelong: "",
//     assignedTo: "",
//     taskStartDate: "",
//     taskEndDate: "",
//     taskType: "",
//     taskPriority: "",
//     taskStatus: "",
//     taskDescription: "",
//     actualStartDate: "",
//     actualEndDate: "",
//     createdBy: username || String(userId) || "",
//   });

//   // Available task fields configuration
//   const availableFields = [
//     {
//       field: "taskName",
//       displayName: "Task Name",
//       type: "text",
//       required: true,
//     },
//     {
//       field: "taskDescription",
//       displayName: "Task Description",
//       type: "textarea",
//       required: false,
//     },
//     {
//       field: "assignedTo",
//       displayName: "Assigned To",
//       type: "select",
//       required: false,
//     },
//     {
//       field: "stageBelong", // Add this field
//       displayName: "Stage",
//       type: "select",
//       required: false,
//     },
//     {
//       field: "taskStartDate",
//       displayName: "Planned Start Date",
//       type: "date",
//       required: false,
//     },
//     {
//       field: "taskEndDate",
//       displayName: "Planned End Date",
//       type: "date",
//       required: false,
//     },
//     {
//       field: "actualStartDate",
//       displayName: "Actual Start Date",
//       type: "date",
//       required: false,
//     },
//     {
//       field: "actualEndDate",
//       displayName: "Actual End Date",
//       type: "date",
//       required: false,
//     },
//     {
//       field: "taskType",
//       displayName: "Task Type",
//       type: "select",
//       required: false,
//     },
//     {
//       field: "taskPriority",
//       displayName: "Priority",
//       type: "select",
//       required: false,
//     },
//     {
//       field: "taskStatus",
//       displayName: "Status",
//       type: "select",
//       required: false,
//     },
//   ];

//   // Function to convert empty strings to null
//   const sanitizeTaskData = (data) => {
//     const sanitized = { ...data };

//     // Convert empty strings to null for all fields except required ones
//     Object.keys(sanitized).forEach((key) => {
//       if (sanitized[key] === "") {
//         sanitized[key] = null;
//       }
//     });

//     // Convert date fields - if they're empty strings, set to null
//     const dateFields = [
//       "taskStartDate",
//       "taskEndDate",
//       "actualStartDate",
//       "actualEndDate",
//     ];
//     dateFields.forEach((field) => {
//       if (sanitized[field] === "") {
//         sanitized[field] = null;
//       }
//     });

//     return sanitized;
//   };

//   // Load templates for the organization
//   const loadTemplates = async () => {
//     if (!orgId) return;

//     setLoadingTemplates(true);
//     try {
//       const templatesData = await getTemplatesByOrg(orgId);
//       console.log("Loaded templates:", templatesData);
//       setTemplates(templatesData || []);
//     } catch (error) {
//       console.error("Error loading templates:", error);
//       toast.error("Failed to load task templates");
//       setTemplates([]);
//     } finally {
//       setLoadingTemplates(false);
//     }
//   };

//   // Handle template selection
//   const handleTemplateSelect = (templateId) => {
//     if (!templateId) {
//       setSelectedTemplate(null);
//       return;
//     }

//     const template = templates.find((t) => t.templateId === templateId);
//     setSelectedTemplate(template);

//     if (template) {
//       toast.info(
//         `Template "${template.templateName}" selected. Showing ${
//           Object.keys(template.includeFields || {}).length
//         } fields.`
//       );
//     }
//   };

//   // Check if a field should be shown based on selected template
//   const shouldShowField = (fieldName) => {
//     // If no template selected, show all fields
//     if (!selectedTemplate) {
//       return true;
//     }

//     // Check if field is included in template
//     return (
//       selectedTemplate.includeFields &&
//       selectedTemplate.includeFields[fieldName]
//     );
//   };

//   // Check if a field is required based on template
//   const isFieldRequired = (fieldName) => {
//     // If no template selected, only required fields are mandatory
//     if (!selectedTemplate) {
//       const fieldConfig = availableFields.find((f) => f.field === fieldName);
//       return fieldConfig?.required || false;
//     }

//     // If template is selected, all included fields are required
//     return (
//       selectedTemplate.includeFields &&
//       selectedTemplate.includeFields[fieldName]
//     );
//   };

//   // Fetch user details for team members
//   const fetchUserDetails = async (userIds) => {
//     if (!userIds || userIds.length === 0) {
//       setTeamMemberDetails([]);
//       return;
//     }

//     try {
//       setLoadingUsers(true);
//       console.log("Fetching user details for IDs:", userIds);

//       const numericUserIds = userIds
//         .map((id) => parseInt(id))
//         .filter((id) => !isNaN(id));

//       if (numericUserIds.length === 0) {
//         console.warn("No valid user IDs to fetch");
//         setTeamMemberDetails([]);
//         return;
//       }

//       const response = await getUsersByIds(numericUserIds);
//       console.log("Fetched User Details:", response);

//       if (response && response.users) {
//         setTeamMemberDetails(response.users);
//         toast.success(`Loaded ${response.users.length} team member details`);
//       } else {
//         setTeamMemberDetails([]);
//         toast.warning("No user details found for team members");
//       }
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       toast.error("Error loading team member details");
//       setTeamMemberDetails([]);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   // Fetch team members when project is selected
//   const fetchTeamMembers = async (teamId) => {
//     if (!teamId) return;

//     try {
//       setLoadingTeam(true);
//       const teamData = await getTeamById(teamId);
//       console.log("Fetched Team Data:", teamData);

//       if (teamData && teamData.teamMembers) {
//         setTeamMembers(teamData.teamMembers);
//         await fetchUserDetails(teamData.teamMembers);
//         toast.info(`Loaded ${teamData.teamMembers.length} team members`);
//       } else {
//         setTeamMembers([]);
//         setTeamMemberDetails([]);
//         toast.warning("No team members found for this project");
//       }
//     } catch (error) {
//       console.error("Error fetching team members:", error);
//       toast.error("Error loading team members");
//       setTeamMembers([]);
//       setTeamMemberDetails([]);
//     } finally {
//       setLoadingTeam(false);
//     }
//   };

//   // Function to load stages for the project
//   const loadProjectStages = async (projectId) => {
//     if (!projectId) return;

//     setLoadingStages(true);
//     try {
//       const stagesData = await fetchStagesByProject(projectId);
//       console.log("Loaded project stages:", stagesData);
//       setStages(stagesData || []);

//       if (stagesData && stagesData.length > 0) {
//         toast.info(`Loaded ${stagesData.length} stages for this project`);
//       } else {
//         toast.warning("No stages found for this project");
//       }
//     } catch (error) {
//       console.error("Error loading project stages:", error);
//       toast.error("Failed to load project stages");
//       setStages([]);
//     } finally {
//       setLoadingStages(false);
//     }
//   };

//   // Fetch only the preselected project data and then get team members
//   // useEffect(() => {
//   //   const fetchPreselectedProject = async () => {
//   //     if (preselectedProjectId) {
//   //       try {
//   //         setLoading(true);
//   //         const projectData = await fetchProjectDetails(preselectedProjectId);
//   //         console.log("Fetched Preselected Project:", projectData);
//   //         setPreselectedProject(projectData);
//   //         setIsProjectPreselected(true);

//   //         toast.info(`Adding task to project: ${projectData.prTitle}`);

//   //         if (projectData.teamAssigned) {
//   //           await fetchTeamMembers(projectData.teamAssigned);
//   //         } else {
//   //           toast.warning("No team assigned to this project");
//   //           setTeamMembers([]);
//   //           setTeamMemberDetails([]);
//   //         }
//   //       } catch (error) {
//   //         console.error("Error fetching preselected project:", error);
//   //         toast.error("Error loading project details");
//   //       } finally {
//   //         setLoading(false);
//   //       }
//   //     }
//   //   };

//   //   if (preselectedProjectId) {
//   //     fetchPreselectedProject();
//   //   }
//   // }, [preselectedProjectId]);

//   // Fetch only the preselected project data and then get team members and stages
//   useEffect(() => {
//     const fetchPreselectedProject = async () => {
//       if (preselectedProjectId) {
//         try {
//           setLoading(true);
//           const projectData = await fetchProjectDetails(preselectedProjectId);
//           console.log("Fetched Preselected Project:", projectData);
//           setPreselectedProject(projectData);
//           setIsProjectPreselected(true);

//           toast.info(`Adding task to project: ${projectData.prTitle}`);

//           // Load team members and stages in parallel
//           await Promise.all([
//             projectData.teamAssigned
//               ? fetchTeamMembers(projectData.teamAssigned)
//               : Promise.resolve(),
//             loadProjectStages(preselectedProjectId),
//           ]);
//         } catch (error) {
//           console.error("Error fetching preselected project:", error);
//           toast.error("Error loading project details");
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     if (preselectedProjectId) {
//       fetchPreselectedProject();
//     }
//   }, [preselectedProjectId]);

//   // Load templates when component mounts
//   useEffect(() => {
//     loadTemplates();
//   }, [orgId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // For select fields, convert empty string to null
//     if (value === "") {
//       setTaskData((prev) => ({ ...prev, [name]: null }));
//     } else {
//       setTaskData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;

//     // Convert empty date strings to null
//     if (value === "") {
//       setTaskData((prev) => ({ ...prev, [name]: null }));
//     } else {
//       setTaskData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);

//   //   try {
//   //     // Validate required fields based on template
//   //     if (selectedTemplate) {
//   //       const missingFields = [];
//   //       Object.keys(selectedTemplate.includeFields || {}).forEach(
//   //         (fieldName) => {
//   //           if (!taskData[fieldName] && taskData[fieldName] !== false) {
//   //             const fieldConfig = availableFields.find(
//   //               (f) => f.field === fieldName
//   //             );
//   //             if (fieldConfig) {
//   //               missingFields.push(fieldConfig.displayName);
//   //             }
//   //           }
//   //         }
//   //       );

//   //       if (missingFields.length > 0) {
//   //         toast.error(
//   //           `Please fill in all required fields: ${missingFields.join(", ")}`
//   //         );
//   //         setLoading(false);
//   //         return;
//   //       }
//   //     }

//   //     // Sanitize the data before sending - convert empty strings to null
//   //     const sanitizedData = sanitizeTaskData(taskData);
//   //     console.log("Sending sanitized task data:", sanitizedData);

//   //     await saveTaskDetails(sanitizedData, username || userId);
//   //     toast.success("🦄 Task Added Successfully");

//   //     // Reset form but keep orgId and createdBy
//   //     setTaskData({
//   //       orgId: String(orgId) || "",
//   //       taskName: "",
//   //       projectBelong: preselectedProjectId || "",
//   //       assignedTo: "",
//   //       taskStartDate: "",
//   //       taskEndDate: "",
//   //       taskType: "",
//   //       taskPriority: "",
//   //       taskStatus: "",
//   //       taskDescription: "",
//   //       actualStartDate: "",
//   //       actualEndDate: "",
//   //       createdBy: username || String(userId) || "",
//   //     });

//   //     // Reset template selection
//   //     setSelectedTemplate(null);

//   //     // Navigate back to project view if task was added from project
//   //     if (preselectedProjectId) {
//   //       navigate(`/project/${preselectedProjectId}`);
//   //     } else {
//   //       navigate("/viewTasks");
//   //     }
//   //   } catch (error) {
//   //     toast.error(`🦄 Error saving task: ${error.message}`);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // Validate required fields based on template
//       if (selectedTemplate) {
//         const missingFields = [];
//         Object.keys(selectedTemplate.includeFields || {}).forEach(
//           (fieldName) => {
//             if (!taskData[fieldName] && taskData[fieldName] !== false) {
//               const fieldConfig = availableFields.find(
//                 (f) => f.field === fieldName
//               );
//               if (fieldConfig) {
//                 missingFields.push(fieldConfig.displayName);
//               }
//             }
//           }
//         );

//         if (missingFields.length > 0) {
//           toast.error(
//             `Please fill in all required fields: ${missingFields.join(", ")}`
//           );
//           setLoading(false);
//           return;
//         }
//       }

//       // Sanitize the data before sending - convert empty strings to null
//       const sanitizedData = sanitizeTaskData(taskData);
//       console.log("Sending sanitized task data:", sanitizedData);

//       await saveTaskDetails(sanitizedData, username || userId);
//       toast.success("🦄 Task Added Successfully");

//       // Reset form but keep orgId and createdBy
//       setTaskData({
//         orgId: String(orgId) || "",
//         taskName: "",
//         projectBelong: preselectedProjectId || "",
//         stageBelong: "", // Reset stageBelong
//         assignedTo: "",
//         taskStartDate: "",
//         taskEndDate: "",
//         taskType: "",
//         taskPriority: "",
//         taskStatus: "",
//         taskDescription: "",
//         actualStartDate: "",
//         actualEndDate: "",
//         createdBy: username || String(userId) || "",
//       });

//       // Reset template selection
//       setSelectedTemplate(null);

//       // Navigate back to project view if task was added from project
//       if (preselectedProjectId) {
//         navigate(`/project/${preselectedProjectId}`);
//       } else {
//         navigate("/viewTasks");
//       }
//     } catch (error) {
//       toast.error(`🦄 Error saving task: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getPreselectedProjectName = () => {
//     if (preselectedProject) {
//       return `${preselectedProject.prTitle} (${preselectedProject.projectId})`;
//     }
//     return "";
//   };

//   // Helper function to get display name for a user
//   const getUserDisplayName = (memberId) => {
//     const userDetail = teamMemberDetails.find(
//       (user) => user.userId === parseInt(memberId)
//     );
//     if (userDetail) {
//       return `${userDetail.username} (${userDetail.email})`;
//     }
//     return memberId;
//   };

//   return (
//     <div className="main-content expand">
//       <Container fluid className="fields-container">
//         <div className="d-flex justify-content-between align-items-center mb-3">
//           <h2 className="fields-title">Task Master</h2>

//           {/* Template Selection Dropdown */}
//           <div className="template-selector" style={{ minWidth: "250px" }}>
//             <Form.Group>
//               <Form.Label>
//                 <strong>Use Template (Optional)</strong>
//               </Form.Label>
//               <Form.Select
//                 value={selectedTemplate?.templateId || ""}
//                 onChange={(e) => handleTemplateSelect(e.target.value)}
//                 disabled={loadingTemplates}
//               >
//                 <option value="">Select a template</option>
//                 {templates.map((template) => (
//                   <option key={template.templateId} value={template.templateId}>
//                     {template.templateName}
//                     {template.includeFields &&
//                       ` (${Object.keys(template.includeFields).length} fields)`}
//                   </option>
//                 ))}
//               </Form.Select>
//               {loadingTemplates && (
//                 <Form.Text className="text-muted">
//                   <small>Loading templates...</small>
//                 </Form.Text>
//               )}
//             </Form.Group>
//           </div>
//         </div>

//         {loading && (
//           <div className="loading-overlay">
//             <Sample14 />
//           </div>
//         )}

//         {/* Show info alert when project is preselected */}
//         {isProjectPreselected && preselectedProject && (
//           <Alert variant="info" className="mb-3">
//             <i className="fas fa-info-circle me-2"></i>
//             You're adding a task to project:{" "}
//             <strong>{getPreselectedProjectName()}</strong>
//             {teamMembers.length > 0 && (
//               <span> - {teamMembers.length} team members available</span>
//             )}
//             {loadingUsers && (
//               <span className="ms-2">
//                 <small>(Loading user details...)</small>
//               </span>
//             )}
//           </Alert>
//         )}

//         {/* Template Info Card */}
//         {selectedTemplate && (
//           <Card className="mb-4 border-primary">
//             <Card.Body className="py-2">
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <strong>Using Template:</strong>{" "}
//                   {selectedTemplate.templateName}
//                   {selectedTemplate.templateDescription && (
//                     <span className="text-muted ms-2">
//                       - {selectedTemplate.templateDescription}
//                     </span>
//                   )}
//                 </div>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={() => setSelectedTemplate(null)}
//                 >
//                   Clear Template
//                 </Button>
//               </div>
//             </Card.Body>
//           </Card>
//         )}

//         <Form onSubmit={handleSubmit} className="fields-form">
//           {/* Basic Task Information */}
//           <Row>
//             {/* Task Name - Always shown as it's required */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Task Name <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="taskName"
//                   value={taskData.taskName || ""}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter task name"
//                 />
//               </Form.Group>
//             </Col>

//             {/* Project - Always shown and pre-selected */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project <span className="text-red">**</span>
//                 </Form.Label>
//                 {isProjectPreselected ? (
//                   <>
//                     <Form.Control
//                       type="text"
//                       value={getPreselectedProjectName()}
//                       disabled
//                       className="bg-light"
//                     />
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       Project is pre-selected. To change, go back to projects.
//                     </Form.Text>
//                   </>
//                 ) : (
//                   <Form.Control
//                     type="text"
//                     value="No project selected"
//                     disabled
//                     className="bg-light"
//                   />
//                 )}
//                 {/* Hidden input to maintain projectBelong value for form submission */}
//                 <Form.Control
//                   type="hidden"
//                   name="projectBelong"
//                   value={taskData.projectBelong || ""}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             {/* Assigned To - Conditionally shown */}
//             {shouldShowField("assignedTo") && (
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Assigned To{" "}
//                     {isFieldRequired("assignedTo") && (
//                       <span className="text-red">**</span>
//                     )}
//                     {(loadingTeam || loadingUsers) && (
//                       <small className="text-muted">(Loading...)</small>
//                     )}
//                   </Form.Label>
//                   <Form.Select
//                     name="assignedTo"
//                     value={taskData.assignedTo || ""}
//                     onChange={handleChange}
//                     disabled={loadingTeam || loadingUsers}
//                     required={isFieldRequired("assignedTo")}
//                   >
//                     <option value="">Select Team Member</option>
//                     {teamMembers.map((memberId) => {
//                       const displayName = getUserDisplayName(memberId);
//                       return (
//                         <option key={memberId} value={memberId}>
//                           {displayName}
//                         </option>
//                       );
//                     })}
//                   </Form.Select>
//                   {teamMembers.length === 0 &&
//                     !loadingTeam &&
//                     !loadingUsers && (
//                       <Form.Text
//                         className="text-muted"
//                         style={{ fontSize: "11px" }}
//                       >
//                         No team members available for this project
//                       </Form.Text>
//                     )}
//                   {(loadingTeam || loadingUsers) && (
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       Loading team members...
//                     </Form.Text>
//                   )}
//                   {teamMemberDetails.length > 0 && !loadingUsers && (
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       {teamMemberDetails.length} team members loaded
//                     </Form.Text>
//                   )}
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Stage - Conditionally shown */}
//             {shouldShowField("stageBelong") && (
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Stage{" "}
//                     {isFieldRequired("stageBelong") && (
//                       <span className="text-red">**</span>
//                     )}
//                     {loadingStages && (
//                       <small className="text-muted">(Loading...)</small>
//                     )}
//                   </Form.Label>
//                   <Form.Select
//                     name="stageBelong"
//                     value={taskData.stageBelong || ""}
//                     onChange={handleChange}
//                     disabled={loadingStages || !preselectedProjectId}
//                     required={isFieldRequired("stageBelong")}
//                   >
//                     <option value="">Select Stage</option>
//                     {stages.map((stage) => (
//                       <option key={stage.stageId} value={stage.stageId}>
//                         {stage.stageName} ({stage.stageId})
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {stages.length === 0 &&
//                     !loadingStages &&
//                     preselectedProjectId && (
//                       <Form.Text
//                         className="text-muted"
//                         style={{ fontSize: "11px" }}
//                       >
//                         No stages found for this project. Create stages in the
//                         project view first.
//                       </Form.Text>
//                     )}
//                   {!preselectedProjectId && (
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       Select a project first to see available stages
//                     </Form.Text>
//                   )}
//                   {loadingStages && (
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       Loading stages...
//                     </Form.Text>
//                   )}
//                   {stages.length > 0 && !loadingStages && (
//                     <Form.Text
//                       className="text-muted"
//                       style={{ fontSize: "11px" }}
//                     >
//                       {stages.length} stage(s) available
//                     </Form.Text>
//                   )}
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Task Type - Conditionally shown */}
//             {shouldShowField("taskType") && (
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Task Type{" "}
//                     {isFieldRequired("taskType") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Select
//                     name="taskType"
//                     value={taskData.taskType || ""}
//                     onChange={handleChange}
//                     required={isFieldRequired("taskType")}
//                   >
//                     <option value="">Select Task Type</option>
//                     <option value="Development">Development</option>
//                     <option value="Design">Design</option>
//                     <option value="Testing">Testing</option>
//                     <option value="Documentation">Documentation</option>
//                     <option value="Research">Research</option>
//                     <option value="Meeting">Meeting</option>
//                     <option value="Maintenance">Maintenance</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             )}
//           </Row>

//           {/* Dates Section */}
//           <Row>
//             {/* Planned Start Date - Conditionally shown */}
//             {shouldShowField("taskStartDate") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Planned Start Date{" "}
//                     {isFieldRequired("taskStartDate") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="taskStartDate"
//                     value={taskData.taskStartDate || ""}
//                     onChange={handleDateChange}
//                     required={isFieldRequired("taskStartDate")}
//                   />
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Planned End Date - Conditionally shown */}
//             {shouldShowField("taskEndDate") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Planned End Date{" "}
//                     {isFieldRequired("taskEndDate") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="taskEndDate"
//                     value={taskData.taskEndDate || ""}
//                     onChange={handleDateChange}
//                     required={isFieldRequired("taskEndDate")}
//                   />
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Actual Start Date - Conditionally shown */}
//             {shouldShowField("actualStartDate") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Actual Start Date{" "}
//                     {isFieldRequired("actualStartDate") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="actualStartDate"
//                     value={taskData.actualStartDate || ""}
//                     onChange={handleDateChange}
//                     required={isFieldRequired("actualStartDate")}
//                   />
//                 </Form.Group>
//               </Col>
//             )}
//           </Row>

//           <Row>
//             {/* Actual End Date - Conditionally shown */}
//             {shouldShowField("actualEndDate") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Actual End Date{" "}
//                     {isFieldRequired("actualEndDate") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="actualEndDate"
//                     value={taskData.actualEndDate || ""}
//                     onChange={handleDateChange}
//                     required={isFieldRequired("actualEndDate")}
//                   />
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Priority - Conditionally shown */}
//             {shouldShowField("taskPriority") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Priority{" "}
//                     {isFieldRequired("taskPriority") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Select
//                     name="taskPriority"
//                     value={taskData.taskPriority || ""}
//                     onChange={handleChange}
//                     required={isFieldRequired("taskPriority")}
//                   >
//                     <option value="">Select Priority</option>
//                     <option value="Low">Low</option>
//                     <option value="Medium">Medium</option>
//                     <option value="High">High</option>
//                     <option value="Critical">Critical</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             )}

//             {/* Status - Conditionally shown */}
//             {shouldShowField("taskStatus") && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Status{" "}
//                     {isFieldRequired("taskStatus") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Select
//                     name="taskStatus"
//                     value={taskData.taskStatus || ""}
//                     onChange={handleChange}
//                     required={isFieldRequired("taskStatus")}
//                   >
//                     <option value="">Select Status</option>
//                     <option value="Not Started">Not Started</option>
//                     <option value="In Progress">In Progress</option>
//                     <option value="On Hold">On Hold</option>
//                     <option value="Completed">Completed</option>
//                     <option value="Cancelled">Cancelled</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             )}
//           </Row>

//           {/* Description - Conditionally shown */}
//           {shouldShowField("taskDescription") && (
//             <Row>
//               <Col md={12}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Task Description{" "}
//                     {isFieldRequired("taskDescription") && (
//                       <span className="text-red">**</span>
//                     )}
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={4}
//                     name="taskDescription"
//                     value={taskData.taskDescription || ""}
//                     onChange={handleChange}
//                     placeholder="Enter detailed task description..."
//                     maxLength={1000}
//                     required={isFieldRequired("taskDescription")}
//                   />
//                   <Form.Text
//                     className="text-muted"
//                     style={{ fontSize: "11px" }}
//                   >
//                     {taskData.taskDescription?.length || 0}/1000 characters
//                   </Form.Text>
//                 </Form.Group>
//               </Col>
//             </Row>
//           )}

//           {/* Info message when template is selected */}
//           {selectedTemplate && (
//             <Alert variant="info" className="mb-3">
//               <i className="fas fa-info-circle me-2"></i>
//               You are using the "
//               <strong>{selectedTemplate.templateName}</strong>" template. Only
//               the selected fields are shown and marked as required.
//             </Alert>
//           )}

//           <div className="fields-btn-container" style={{ display: "flex" }}>
//             <Button
//               variant="primary"
//               type="submit"
//               className="fields-submit"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Task"}
//             </Button>
//             <Button
//               variant="secondary"
//               type="button"
//               className="fields-cancel ms-2"
//               onClick={() => {
//                 if (preselectedProjectId) {
//                   navigate(`/project/${preselectedProjectId}`);
//                 } else {
//                   navigate("/viewTasks");
//                 }
//               }}
//             >
//               Cancel
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   );
// };

// export default TaskMaster;
